import React, { Component } from 'react';
import './account.scss';

import infoIcon from '../../../assets/images/info-icon.svg';
import { formatCurrency, formatSortCode } from '../../../utils/helpers';
import withFeatureFlags from '../../FeatureFlags/withFeatureFlags';
import '../../SharedComponents/button-styles.scss';
import FlipCard, {FlipCardFront} from '../../../components/FlipCard/FlipCard';

/** @import { WithFeatureFlagsProps } from '../../FeatureFlags/FeatureFlagsTypes' */
/** @import { AccountDetailsProps,AccountDetailsState } from './AccountDetailsTypes' */

/** @extends {Component<AccountDetailsProps & WithFeatureFlagsProps, AccountDetailsState>} */ 
class AccountDetails extends Component {
    /** @type {AccountDetailsState} */
    state = {
        blendedRateOpen: false,
        blendedAccountOpen: false,
        flipped: false,
        action: null,
        accountActivitiesEnabled: false,
        showPopupInline: null
    };

    toggleInfo = (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) => {
        event.preventDefault();

        if (this.props.showPopup && !this.props.showPopup(event, () => this.renderBlendedRate())) {
            this.setState(({showPopupInline}) => ({
                showPopupInline: showPopupInline ? null : 'BLENDED_RATE'
            }))
        }
    };

    renderBlendedRate() {
        const {account} = this.props;
        return (
            <>
                <h3 className="account__blended-rate-title">What's the interest rate?</h3>
                <ul className="account__blended-rate-items">
                    {
                        account.product.interestRateTiers && account.product.interestRateTiers
                            .sort((a, b) => a.minBalance > b.minBalance ? -1 : 1)
                            .map((tier, index) => {
                                return tier.rate === 0.00
                                    ? (<li className="account__blended-rate-item" key={index}>However, if it's equal to or
                                        under {formatCurrency(tier.maxBalance)}, you won't earn any interest.</li>)
                                    : (<li className="account__blended-rate-item" key={index}>You'll
                                        earn {tier.rate.toFixed(2)}%^ on your <b>entire</b> balance when it's
                                        between {formatCurrency(tier.minBalance)} - {formatCurrency(tier.maxBalance)}.
                                    </li>)
                            })
                    }
                    <li className="account__blended-rate-item" key={account.product.interestRateTiers && account.product.interestRateTiers.length}>^This is
                        gross p.a., which is the rate you earn per year before tax.
                    </li>
                </ul>
            </>
        );
    };

    render() {
        const {account, customer, issueNumber, enableBlendedRatePopup} = this.props;
        const { flipped } = this.state;

        return (
            <div className="account__section-left">
                <FlipCard flipped={flipped}>
                    <FlipCardFront>
                        {this.props.overrideAccountName ?
                            <h3 className="account__name">{this.props.overrideAccountName}{typeof issueNumber == 'number' && (<span className="account__name--light"> Issue {issueNumber}</span>)}</h3> :
                            <h3 className="account__name">{account.product.name}{typeof issueNumber == 'number' && (<span className="account__name--light"> Issue {issueNumber}</span>)}</h3>
                        }
                        <div className="account__container_table">
                            <div className="account__container_row">
                                <div className="account__container_sideBySide">
                                    <div className="account__container_column account__interest-rate account__info-key">
                                        Account no.
                                    </div>
                                    <div className="account__container_column account__interest-rate account__info-value" data-accountnumber>
                                        {account.accountNumber}
                                    </div>
                                </div>
                                <div className="account__container_sideBySide">
                                    <div className="account__container_column account__interest-rate account__info-key">
                                        Sort code
                                    </div>
                                    <div
                                        className="account__container_column account__interest-rate account__info-value">
                                        {formatSortCode(account.sortCode)}
                                    </div>
                                </div>
                            </div>
                            <div className="account__container_row">
                                <div className="account__container_sideBySide">
                                    <div className="account__container_column account__interest-rate account__info-key">
                                        Account holder
                                    </div>
                                    <div
                                        className="account__container_column account__interest-rate account__info-value">
                                        {customer.firstName} {customer.middleName} {customer.lastName}
                                    </div>
                                </div>
                                <div className="account__container_sideBySide">
                                    <div className="account__container_column account__interest-rate account__info-key">
                                        Interest rate
                                    </div>
                                    
                                    <div className="account__container_column">
                                            <div>
                                                <span className="account__interest-rate account__info-value">
                                                    {account.product.interestRate.toFixed(2)}&nbsp;%&nbsp;
                                                    {enableBlendedRatePopup && (
                                                        <a onClick={this.toggleInfo}><img className="account__interest-rate-info" src={infoIcon}/></a>
                                                    )}
                                                </span>
                                            </div>
                                    </div>
                                </div>
                                {enableBlendedRatePopup && this.state.showPopupInline === 'BLENDED_RATE' && (
                                    <div className="account__inline-popup is-open">
                                        {this.renderBlendedRate()}
                                    </div>)}
                            </div>
                        </div>
                    </FlipCardFront>
                </FlipCard>
            </div>
        );
    }
}

export default withFeatureFlags(AccountDetails);
